import * as Font from 'expo-font';

const useFonts = async () => {
    await Font.loadAsync({
        dmsans: require('../assets/fonts/DMSans.otf'),
    });
};

export default useFonts;
